export default "__VITE_ASSET__CSdDqrTo__"